var moduleMap = {
	"./base.scss": () => {
		return Promise.all([__webpack_require__.e(309), __webpack_require__.e(6627)]).then(() => (() => ((__webpack_require__(86627)))));
	},
	"./shell": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(7894), __webpack_require__.e(8974), __webpack_require__.e(7099), __webpack_require__.e(2982), __webpack_require__.e(1275), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(6073), __webpack_require__.e(1193), __webpack_require__.e(9450), __webpack_require__.e(309), __webpack_require__.e(2273), __webpack_require__.e(8553), __webpack_require__.e(4946), __webpack_require__.e(8348), __webpack_require__.e(92)]).then(() => (() => ((__webpack_require__(10092)))));
	},
	"./en/error": () => {
		return __webpack_require__.e(4976).then(() => (() => ((__webpack_require__(94976)))));
	},
	"./ms/error": () => {
		return __webpack_require__.e(8882).then(() => (() => ((__webpack_require__(68882)))));
	},
	"./shared/components": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(7894), __webpack_require__.e(8974), __webpack_require__.e(7099), __webpack_require__.e(1275), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(6073), __webpack_require__.e(1193), __webpack_require__.e(9450), __webpack_require__.e(2273), __webpack_require__.e(8553), __webpack_require__.e(8348)]).then(() => (() => ((__webpack_require__(54068)))));
	},
	"./shared/hooks": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(7894), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(6073), __webpack_require__.e(1193), __webpack_require__.e(8553), __webpack_require__.e(3702)]).then(() => (() => ((__webpack_require__(38553)))));
	},
	"./shared/helpers": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(4364)]).then(() => (() => ((__webpack_require__(34364)))));
	},
	"./shared/recoil/org": () => {
		return Promise.all([__webpack_require__.e(6073), __webpack_require__.e(4853)]).then(() => (() => ((__webpack_require__(54853)))));
	},
	"./shared/utils": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(7894), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(6073), __webpack_require__.e(1193), __webpack_require__.e(8553), __webpack_require__.e(3702)]).then(() => (() => ((__webpack_require__(29438)))));
	},
	"./shared/validations": () => {
		return __webpack_require__.e(1994).then(() => (() => ((__webpack_require__(1994)))));
	},
	"./shared/constants": () => {
		return __webpack_require__.e(3203).then(() => (() => ((__webpack_require__(43203)))));
	},
	"./shared/normalizer": () => {
		return Promise.all([__webpack_require__.e(6110), __webpack_require__.e(3704), __webpack_require__.e(8949), __webpack_require__.e(2678), __webpack_require__.e(6927), __webpack_require__.e(5781), __webpack_require__.e(1035), __webpack_require__.e(5661)]).then(() => (() => ((__webpack_require__(35661)))));
	},
	"./shared/data": () => {
		return __webpack_require__.e(2273).then(() => (() => ((__webpack_require__(2273)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});